import React from "react";
import { useAppSelector } from "@litres-core/store";
import { useTranslation } from "@litres-libs/i18n";

export const MainLogo = () => {
  const { t } = useTranslation();
  const isDesktop = useAppSelector(state => !state.browser.pda);
  const isInternationalDomain =
    useAppSelector(state => state.face.language) !== "ru";

  return (
    <img
      src={
        isInternationalDomain
          ? "https://cdn.litres.ru/static/litres/logo/logo_int.svg"
          : "https://cdn.litres.ru/static/litres/logo/logo_ru.svg"
      }
      width={isDesktop ? 178 : 99}
      height={isDesktop ? 28 : 24}
      alt={t("Логотип Литрес")}
    />
  );
};
